<template>
  <div class="widget style1" :class="cardClass">
    <div class="row">
      <div class="col-xs-4">
        <i :class="icon"></i>
      </div>
      <div class="col-xs-8 text-right">
        <span> {{title}} </span>
        <h2 class="font-bold counter number">{{currentNumber}}</h2>
      </div>
    </div>
  </div>
</template>
<script>

export default{
  name: "HoizontalCards",
  data() {
    return {
      currentNumber: 0,
    };
  },
  mounted() {
    // The watcher below only fires when `stat` changes. When the value is already loaded
    // before this card mounts (a cached Vuex count, a page visited after its data landed)
    // it never fires and the card is stuck showing 0, so run the count-up once on mount.
    this.startAnimation();
  },
  watch: {
    stat(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.startAnimation();
      }
    },
  },
  props: {
    cardClass: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: 'blue-bg',
      required: true
    },
    title: {
      type: String,
      required: true
    },
    stat: {
      type: Number,
      default: 0,
      required: true
    },
    animationDuration: {
      type: Number,
      default: 2000, // Default animation duration in milliseconds
    },

  },
  methods: {
    startAnimation() {
      let startTime;
      const step = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const progress = timestamp - startTime;
        this.currentNumber = Math.round((this.stat * progress) / this.animationDuration);
        if (progress < this.animationDuration) {
          requestAnimationFrame(step);
        } else {
          this.currentNumber = this.stat; // Ensure the target number is reached precisely
        }
      };
      requestAnimationFrame(step);
    },
  },
}
</script>

<style scoped>
.number {
  font-size: 24px;
  transition: all 0.5s; /* Optional CSS transition for smooth updates */
}
</style>